export const JD_PRECHECK_NETWORK_FALLBACK =
  'We could not verify this job description right now. You can try again, or continue and the server will check when you start optimization.'

export const JD_PRECHECK_LOADING_LABEL = 'Checking job description security…'
